<template>
  <v-expansion-panels v-model="panelsLocal" accordion multiple flat>
    <v-expansion-panel
      v-if="!(baseSelecionada === 'servicos' && showOnlyTiposServicos)"
      class="borda"
    >
      <v-expansion-panel-header>
        Campos Selecionados
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row dense>
          <v-col cols="12">
            <h4>Categorias de Campos</h4>
          </v-col>
          <v-col class="pb-0 pt-0" cols="12">
            <v-checkbox
              v-model="selectAllCategories"
              label="Selecionar tudo"
              hide-details
              class="mt-0"
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-chip-group v-model="selectedCategories" column multiple>
              <v-chip
                v-for="category in formattedFieldsCategories"
                :key="category.slug"
                :ripple="false"
                filter
                outlined
                :value="category.slug"
              >
                {{ category.category }}
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>

        <v-row dense class="mt-4">
          <v-col cols="12">
            <h4>Campos</h4>
          </v-col>
          <v-col v-if="selectedFields.length < 1" cols="12" class="caption">
            <strong style="color: red;">Selecione pelo menos 1 campo</strong>
          </v-col>
          <v-col class="pb-0 pt-0" cols="12">
            <v-checkbox
              v-model="selectAllFields"
              label="Selecionar tudo"
              hide-details
              class="mt-0"
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-chip-group v-model="selectedFields" column mandatory multiple>
              <v-chip
                v-for="fields in availableFields"
                :key="fields"
                filter
                outlined
                :value="fields"
              >
                {{ fields.toUpperCase() }}
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel
      v-if="baseSelecionada === 'servicos' && !showOnlyCamposCategorias"
      class="borda"
    >
      <v-expansion-panel-header>
        Tipos de Serviço Selecionados
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row dense>
          <v-col cols="12">
            <h4>Categorias de Serviços</h4>
          </v-col>
          <v-col class="pb-0 pt-0" cols="12">
            <v-checkbox
              v-model="selectAllServicoCategories"
              label="Selecionar tudo"
              hide-details
              class="mt-0"
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-chip-group v-model="selectedServicosCategories" column multiple>
              <v-chip
                v-for="categoria in servicosCategories"
                :key="categoria.id"
                :ripple="false"
                filter
                outlined
                :value="categoria.id"
              >
                {{ categoria.nome }}
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>

        <v-row dense class="mt-4">
          <v-col cols="12">
            <h4>Tipos de Serviços</h4>
          </v-col>
          <v-col
            v-if="selectedTiposServicos.length < 1"
            cols="12"
            class="caption"
          >
            <strong style="color: red;"
              >Selecione pelo menos 1 tipo de serviço</strong
            >
          </v-col>
          <v-col class="pb-0 pt-0" cols="12">
            <v-checkbox
              v-model="selectAllTiposServicos"
              label="Selecionar tudo"
              hide-details
              class="mt-0"
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-chip-group
              v-model="selectedTiposServicos"
              column
              mandatory
              multiple
            >
              <v-chip
                v-for="tipoServico in tiposServicos"
                :key="tipoServico"
                filter
                outlined
                :value="tipoServico"
              >
                {{ tipoServico }}
              </v-chip>
            </v-chip-group>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  import UsersService from "@/services/UsersService";

  export default {
    name: "SelectTemasIndger",
    emits: [
      "selectedCategories:changed",
      "selectedFields:changed",
      "selectedServicesCategories:changed",
      "selectedTiposServicos:changed",
    ],
    props: {
      panels: {
        type: Array,
        default: () => [],
      },
      baseSelecionada: {
        type: String,
        required: true,
        validator: (value) =>
          ["comercial", "servicos", "tec_al", "tec_sub", "tec_ld"].includes(
            value
          ),
      },
      initialSelectedCategories: { type: Array, default: () => [] },
      initialSelectedFields: { type: Array, default: () => [] },
      initialSelectedServicosCategories: { type: Array, default: () => [] },
      initialSelectedTiposServicos: { type: Array, default: () => [] },
      showOnlyTiposServicos: {
        type: Boolean,
        default: false,
      },
      showOnlyCamposCategorias: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        indicadoresFieldsCategories: [],
        selectAllCategories: false,
        selectAllFields: false,
        selectAllServicoCategories: false,
        selectAllTiposServicos: false,
        selectedCategories: [...this.initialSelectedCategories],
        selectedFields: [...this.initialSelectedFields],
        selectedServicosCategories: [...this.initialSelectedServicosCategories],
        selectedTiposServicos: [...this.initialSelectedTiposServicos],
      };
    },
    computed: {
      availableFields() {
        let fields = this.formattedFieldsCategories
          .map((el) => el.fields)
          .flat();
        return Array.from(new Set(fields));
      },
      formattedFieldsCategories() {
        const fieldsCategories = {
          comercial: this.indicadoresFieldsCategories?.fields_indicadores_comerciais_v2_categories?.map(
            (category) => {
              return {
                slug: category.slug,
                category: category.category,
                fields: category.fields.map((f) => f.field),
              };
            }
          ),
          servicos: this.indicadoresFieldsCategories?.fields_indicadores_servicos_v2_categories?.map(
            (category) => {
              return {
                slug: category.slug,
                category: category.category,
                fields: category.fields.map((f) => f.field),
              };
            }
          ),
          tec_al: this.indicadoresFieldsCategories?.fields_indicadores_alimentadores_categories?.map(
            (category) => {
              return {
                slug: category.slug,
                category: category.category,
                fields: category.fields.map((f) => f.field),
              };
            }
          ),
          tec_sub: this.indicadoresFieldsCategories?.fields_indicadores_subestacoes_categories?.map(
            (category) => {
              return {
                slug: category.slug,
                category: category.category,
                fields: category.fields.map((f) => f.field),
              };
            }
          ),
          tec_ld: this.indicadoresFieldsCategories?.fields_indicadores_linhas_distribuicao_categories?.map(
            (category) => {
              return {
                slug: category.slug,
                category: category.category,
                fields: category.fields.map((f) => f.field),
              };
            }
          ),
        };

        return fieldsCategories[this.baseSelecionada] ?? [];
      },
      servicosCategories() {
        return this.indicadoresFieldsCategories?.servicos_categories?.map(
          (category) => {
            return {
              id: category.id,
              nome: category.nome,
              tipos_servicos: category.tipos_servicos.map((ts) => ts.codigo),
            };
          }
        );
      },
      tiposServicos() {
        let tiposServicos = this.servicosCategories
          ?.map((el) => el.tipos_servicos)
          .flat()
          .sort((a, b) => a - b);
        return Array.from(new Set(tiposServicos));
      },
      panelsLocal: {
        get() {
          return this.panels;
        },
        set(value) {
          this.$emit("update:panels", value);
        },
      },
    },
    created() {
      this.getIndicadoresFieldsCategories();
    },
    methods: {
      getIndicadoresFieldsCategories() {
        return UsersService.getIndicadoresFieldsCategories()
          .then((res) => {
            this.indicadoresFieldsCategories = res;
          })
          .catch((err) => {
            this.$toast.error("Erro ao recuperar temas dos indicadores.", "", {
              position: "topRight",
            });
            throw err;
          });
      },
      setSelectedTiposServicosByCategoriasServicos() {
        let tiposServicos = [];
        this.selectedServicosCategories.forEach((servicoId) => {
          let category = this.servicosCategories.find(
            (category) => category.id === servicoId
          );
          if (category) {
            tiposServicos = tiposServicos.concat(category.tipos_servicos);
          }
        });
        this.selectedTiposServicos = Array.from(new Set(tiposServicos));
      },
      setSelectedFieldsByCategories() {
        let fields = [];
        this.selectedCategories.forEach((categorySlug) => {
          let category = this.formattedFieldsCategories.find(
            (category) => category.slug === categorySlug
          );
          if (category) {
            fields = fields.concat(category.fields);
          }
        });
        this.selectedFields = Array.from(new Set(fields));
      },
    },
    watch: {
      selectAllCategories() {
        this.selectedCategories = this.selectAllCategories
          ? this.formattedFieldsCategories.map((category) => category.slug)
          : [];
      },
      selectedCategories() {
        this.setSelectedFieldsByCategories();
        this.$emit("selectedCategories:changed", this.selectedCategories);
      },
      selectAllFields() {
        this.selectedFields = this.selectAllFields ? this.availableFields : [];
      },
      selectedFields() {
        this.$emit("selectedFields:changed", this.selectedFields);
      },
      selectedServicosCategories() {
        this.setSelectedTiposServicosByCategoriasServicos();
        this.$emit(
          "selectedServicesCategories:changed",
          this.selectedServicosCategories
        );
      },
      selectAllServicoCategories() {
        this.selectedServicosCategories = this.selectAllServicoCategories
          ? this.servicosCategories.map((categoria) => categoria.id)
          : [];
      },
      selectedTiposServicos() {
        this.$emit("selectedTiposServicos:changed", this.selectedTiposServicos);
      },
      selectAllTiposServicos() {
        this.selectedTiposServicos = this.selectAllTiposServicos
          ? this.tiposServicos
          : [];
      },
    },
  };
</script>